import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const businessPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', to: '/' }];

export const childrenBusinessPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Sistema de envíos', to: '/business' }];

export const childrenLogisticsNetworkPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business' },
  { label: 'Red logística', to: '/business/logistics-network' },
];
